import type {
  ConnectorConnection,
  ConnectorProject,
} from '@saaga/shared/interfaces/connector.interface'
import type { ReactNode } from 'react'
import { ConnectorProjectList } from '@/components/connectors/connector-project-list.molecule'
import { Separator } from '@/components/ui/separator'

interface ConnectorDetailProjectsProps {
  connection: ConnectorConnection | null
  projectList: ConnectorProject[]
  onToggleActive: (projectId: string, isActive: boolean) => void
}

export const ConnectorDetailProjects: React.FC<ConnectorDetailProjectsProps> = ({
  connection,
  projectList,
  onToggleActive,
}: ConnectorDetailProjectsProps): ReactNode => {
  if (!connection) return null

  return (
    <>
      <Separator />
      <ConnectorProjectList
        projectList={projectList}
        connectionDisplayName={connection.providerAccountId}
        onToggleActive={onToggleActive}
      />
    </>
  )
}

ConnectorDetailProjects.displayName = 'ConnectorDetailProjects'
